export enum EAccountStatus {
  DISCONNECTED = 'DISCONNECTED',
  TOKEN_GRANTED = 'TOKEN_GRANTED',
  CONNECTED = 'CONNECTED',
}
